import * as Yup from "yup";

import {IRange} from "@pg-design/inputs-module";

import {validationMessages} from "../../form/utils/validation_messages";
import {SearchTab} from "../../search/actions/fetch_search_all_action";
import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";

export enum PhoneType {
    Whatsapp,
    Sms,
    None
}

export const offerChatBotFormValidationSchema = Yup.object({
    search: Yup.object({
        regions: Yup.array().min(1).required()
    }),
    rooms: Yup.object({
        lower: Yup.number(),
        upper: Yup.number()
    }).test("required", validationMessages.required, (value) => {
        return Boolean((value.lower && value.lower > 0) || (value.upper && value.upper > 0));
    }),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().matches(new RegExp("^[0-9]{9,14}$"), {message: validationMessages.phone}).required(validationMessages.required)
    }),
    phone_type: Yup.string().required(validationMessages.required),
    general_marketing_consent: Yup.boolean().isTrue(validationMessages.required).required(validationMessages.required)
});

export interface IOfferNotificationChatBotFormValues {
    search: {
        label: string;
        tabType: SearchTab.Regions;
        regions: IRegionListRegion[];
    };
    rooms: IRange<number | "">;
    phone_type: PhoneType;
    phone: {
        code: number;
        number: string;
    };
    general_marketing_consent: boolean;
}

export const offerNotificationChatBotFormInitialValues: IOfferNotificationChatBotFormValues = {
    search: {
        label: "",
        tabType: SearchTab.Regions,
        regions: []
    },
    rooms: {
        lower: "",
        upper: ""
    },
    phone: {
        code: 48,
        number: ""
    },
    phone_type: PhoneType.Sms,
    general_marketing_consent: false
};
import * as Yup from "yup";

import {IRange} from "@pg-design/inputs-module";

import {validationMessages} from "../../form/utils/validation_messages";
import {SearchTab} from "../../search/actions/fetch_search_all_action";
import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";

export enum PhoneType {
    Whatsapp,
    Sms,
    None
}

export const offerChatBotFormValidationSchema = Yup.object({
    search: Yup.object({
        regions: Yup.array().min(1).required()
    }),
    rooms: Yup.object({
        lower: Yup.number(),
        upper: Yup.number()
    }).test("required", validationMessages.required, (value) => {
        return Boolean((value.lower && value.lower > 0) || (value.upper && value.upper > 0));
    }),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().matches(new RegExp("^[0-9]{9,14}$"), {message: validationMessages.phone}).required(validationMessages.required)
    }),
    phone_type: Yup.string().required(validationMessages.required),
    general_marketing_consent: Yup.boolean().isTrue(validationMessages.required).required(validationMessages.required)
});

export interface IOfferNotificationChatBotFormValues {
    search: {
        label: string;
        tabType: SearchTab.Regions;
        regions: IRegionListRegion[];
    };
    rooms: IRange<number | "">;
    phone_type: PhoneType;
    phone: {
        code: number;
        number: string;
    };
    general_marketing_consent: boolean;
}

export const offerNotificationChatBotFormInitialValues: IOfferNotificationChatBotFormValues = {
    search: {
        label: "",
        tabType: SearchTab.Regions,
        regions: []
    },
    rooms: {
        lower: "",
        upper: ""
    },
    phone: {
        code: 48,
        number: ""
    },
    phone_type: PhoneType.Sms,
    general_marketing_consent: false
};
